// extracted by mini-css-extract-plugin
export var box = "Main-module--box--6b769";
export var box_md = "Main-module--box_md--a8bf9";
export var box_xmd = "Main-module--box_xmd--89d15";
export var box_flex = "Main-module--box_flex--1c211";
export var box_lg = "Main-module--box_lg--0096a";
export var box_sm = "Main-module--box_sm--370a7";
export var box_outer = "Main-module--box_outer--ab66e";
export var box_whiteBg = "Main-module--box_white-bg--1e24c";
export var box_noMarginBottom = "Main-module--box_no-margin-bottom--a6bd4";
export var box_noPadding = "Main-module--box_no-padding--7bca1";
export var box_outerGray = "Main-module--box_outer-gray--d1fe9";
export var box_dark = "Main-module--box_dark--f5807";
export var box_zIndex = "Main-module--box_z-index--b4b04";
export var box_zIndex6 = "Main-module--box_z-index-6--387fe";
export var box_eventsWithLine = "Main-module--box_events-with-line--c2a98";
export var box_featuresAo = "Main-module--box_features-ao--d8fd8";
export var box_verticalPaddings = "Main-module--box_vertical-paddings--96e33";
export var clearP = "Main-module--clearP--01ac0";
export var clearP_vc = "Main-module--clearP_vc--0151a";
export var content = "Main-module--content--7f069";
export var topPaddingNone = "Main-module--topPaddingNone--c4205";
export var bottomPaddingNone = "Main-module--bottomPaddingNone--2bf7c";
export var marginDisable = "Main-module--marginDisable--3b18b";
export var whiteBG = "Main-module--whiteBG--82c3c";
export var scrollY = "Main-module--scrollY--c2833";
export var stretchViewportHeight = "Main-module--stretchViewportHeight--b4bc2";
export var hidden = "Main-module--hidden--9b1c5";
export var fadeInAnimation = "Main-module--fadeInAnimation--7d2fa";
export var placeHolderShimmer = "Main-module--placeHolderShimmer--74287";